import { render } from "./TipStatistics.vue?vue&type=template&id=3e4fd0e2&scoped=true"
import script from "./TipStatistics.vue?vue&type=script&lang=js"
export * from "./TipStatistics.vue?vue&type=script&lang=js"

import "./TipStatistics.vue?vue&type=style&index=0&id=3e4fd0e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e4fd0e2"]])

export default __exports__